import _ from "lodash";

export interface SubjectReference {
    uri: string;
    label: string;
    values: _.Dictionary<string>;
}
